module.exports = __webpack_public_path__ + "img/IMG_8923.bd0e36b9.jpg";